import { MAIN_IMAGE_ROOT } from 'app_config';
import { Button, ImageComponent, Modal } from 'components';
import { getCustomerKindTranslateKey } from 'helpers/customerHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { CustomerKind } from 'pages/customers/models';
import { CustomerKindArray } from 'pages/customers/models';
import React, { useState } from 'react';

import PublicOrderRequestInfoContent from './PublicOrderRequestInfoContent';

interface PublicOrderRequestHeaderProps {
  logoUrl?: string | null;
  companyName?: string;
  orderRequestInfoPageContent?: string | null;
  defaultCustomerKind?: CustomerKind;
  setDefaultCustomerKind: (kind: CustomerKind) => void;
  successfullySubmitted: boolean;
  setSuccessfullySubmitted: () => void;
}

const PublicOrderRequestHeader = ({
  logoUrl,
  companyName,
  orderRequestInfoPageContent,
  setDefaultCustomerKind,
  defaultCustomerKind,
  successfullySubmitted,
  setSuccessfullySubmitted
}: PublicOrderRequestHeaderProps) => {
  const { tRequest, tCustomer, tCommon } = useCustomTranslation();
  const [showInfoModal, setShowInfoModal] = useState(false);

  if (successfullySubmitted) {
    return (
      <div className="PublicOrderRequestHeader">
        <div className="PublicOrderRequestHeader_logo">
          <ImageComponent
            url={logoUrl ? `${MAIN_IMAGE_ROOT}${logoUrl}` : ''}
            className="img-fluid"
          />
        </div>
        <div className="PublicOrderRequestHeader_title">
          {tRequest('public_form_success', {
            companyName
          })}
        </div>
        <div className="PublicOrderRequestHeader_description">
          {tRequest('public_form_success_description')}
        </div>
        <div className="PublicOrderRequestHeader_kindSelect">
          <Button type="primary" onClick={() => setSuccessfullySubmitted()}>
            {tRequest('public_form_new_button')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="PublicOrderRequestHeader">
      {logoUrl && (
        <div className="PublicOrderRequestHeader_logo">
          <ImageComponent
            url={logoUrl ? `${MAIN_IMAGE_ROOT}${logoUrl}` : ''}
            className="img-fluid"
          />
        </div>
      )}
      <div className="PublicOrderRequestHeader_title">
        {tRequest('public_form_title', {
          companyName
        })}
      </div>
      <div
        className={`PublicOrderRequestHeader_description${
          orderRequestInfoPageContent?.trim() ? ' with-more-info' : ''
        }`}
      >
        {tRequest('public_form_description')}
      </div>
      {orderRequestInfoPageContent?.trim() && (
        <div className="PublicOrderRequestHeader_moreInfo">
          <Button type="link" onClick={() => setShowInfoModal(true)}>
            {tCommon('more_info')}
          </Button>
          <Modal
            open={showInfoModal}
            onClose={() => setShowInfoModal(false)}
            title={tCommon('more_info')}
            width={720}
            maskClosable
          >
            <PublicOrderRequestInfoContent content={orderRequestInfoPageContent} />
          </Modal>
        </div>
      )}
      {!defaultCustomerKind && (
        <div className="PublicOrderRequestHeader_kindSelect">
          {CustomerKindArray.map((kind) => (
            <Button type="primary" key={kind} onClick={() => setDefaultCustomerKind(kind)}>
              {tCustomer(getCustomerKindTranslateKey(kind))}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicOrderRequestHeader;
